import _ from 'lodash';

// A curriculum has either themes or sessions attached directly, never both —
// the backend rejects a mix.
export const hasThemes = sessionStatuses =>
  _.some(sessionStatuses, s => _.get(s, 'session.theme.id'));

const themeOrderOf = sessionStatus => _.get(sessionStatus, 'session.theme.order', 0);

const sessionOrderOf = sessionStatus =>
  _.get(
    sessionStatus,
    'session.themeSessionOrder',
    _.get(sessionStatus, 'session.displayOrder', 0),
  );

// `display_order` is theme_order * 1000 + session_order, so one sort covers
// both; fall back to the two fields when it is missing.
export const orderByTheme = sessionStatuses =>
  _.sortBy(sessionStatuses, [
    s => _.get(s, 'session.displayOrder', themeOrderOf(s) * 1000 + sessionOrderOf(s)),
    s => _.get(s, 'session.id'),
  ]);

// Themes in curriculum order, each with its sessions in session order. A theme
// is achieved once every session it contains is completed.
export const groupSessionsByTheme = sessionStatuses => {
  const withTheme = _.filter(sessionStatuses, s => _.get(s, 'session.theme.id'));

  const themes = _.map(
    _.groupBy(withTheme, s => _.get(s, 'session.theme.id')),
    grouped => {
      const theme = _.get(grouped, '[0].session.theme');
      const sessions = _.sortBy(grouped, [sessionOrderOf, s => _.get(s, 'session.id')]);
      return {
        id: theme.id,
        title: theme.title,
        banner: theme.banner,
        order: _.get(theme, 'order', 0),
        sessions,
        isComplete: _.every(sessions, s => s.status === 'COMPLETED'),
      };
    },
  );

  return _.sortBy(themes, ['order', 'id']);
};

// Falls back to the last session once everything is done.
export const nextSession = sessionStatuses => {
  const ordered = orderByTheme(sessionStatuses);
  return _.find(ordered, s => s.status !== 'COMPLETED') || _.last(ordered);
};

export const isFirstSession = (sessionStatuses, sessionStatus) =>
  _.get(_.head(orderByTheme(sessionStatuses)), 'session.id') === _.get(sessionStatus, 'session.id');

// The first unachieved theme — where the user is meant to be working.
export const activeThemeIndex = themes => {
  const index = _.findIndex(themes, theme => !theme.isComplete);
  return index === -1 ? themes.length - 1 : index;
};
